import { render, staticRenderFns } from "./AtcRequirementPending.vue?vue&type=template&id=1d920474&"
import script from "./AtcRequirementPending.vue?vue&type=script&lang=js&"
export * from "./AtcRequirementPending.vue?vue&type=script&lang=js&"
import style0 from "./AtcRequirementPending.vue?vue&type=style&index=0&id=1d920474&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports